export const environment = {
    name: 'production',
    production: true,
    apiConfiguration: {
        basePath: '/availability-calendar/api',
        paths: {
            config: '/config',
            calendar: '/calendar',
            translate: '/translate',
            pageKeyData: '/page-key-data/%s'
        }
    },
    comSharedApi: {
        basePath: '/com-shared/api',
        paths: {
            content: '/content/rb/'
        }
    },
    analyticsServerPath: 'availability-calendar/analytics'
};
